import { Injectable } from '@angular/core';

@Injectable()
export class GlobalVariableService {
    public api_client_id: string = 'F1F82771-BECB-2FCF-5BDBEFACBE319A25';
    public api_redirect_uri: string = 'https://connect.airsquare.com/oauth2/callback-pos.html';
    public version: string = "2.8.5";
}